var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M57.9 988.7s-26-207 157.4-364.3 410-93.5 410-93.5 127.1 22.2 230.2 137.7S972.4 919 967.3 987.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M511.8 74.5c54.8 0 106.2 21.3 145 60 38.7 38.7 60 90.2 60 145s-21.3 106.2-60 145c-38.7 38.7-90.2 60-145 60s-106.2-21.3-145-60c-38.7-38.7-60-90.2-60-145s21.3-106.2 60-145c38.7-38.7 90.2-60 145-60m0-65c-149.1 0-270 120.9-270 270s120.9 270 270 270 270-120.9 270-270-120.9-270-270-270z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default ForwardRef;